import React from "react"
import ReactModal from "react-modal"

const ModalAdapter = ({ ...props }: any) => {
  return <ReactModal {...props} />
}

export default ModalAdapter
